import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { environment } from '../../environments/environment';
import { FundingBankAccount, FundMovement, FundMovementUpdate } from '../models/fund-movement/fund-movement';

/** Fund movements (#5786): the opening that funds a fund ready for funding. */
@Injectable({ providedIn: 'root' })
export class FundMovementProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/fund-movement';

  public getByFund(fundId: string): Observable<ApiResponse<FundMovement[]>> {
    return this.httpClient.get<ApiResponse<FundMovement[]>>(`${this.baseUrl}/by-fund/${fundId}`);
  }

  public getFundingBankAccounts(fundId: string): Observable<ApiResponse<FundingBankAccount[]>> {
    return this.httpClient.get<ApiResponse<FundingBankAccount[]>>(`${this.baseUrl}/funding-bank-accounts/${fundId}`);
  }

  /** Creates or updates the fund's Draft opening. */
  public saveOpening(fundId: string, payload: FundMovementUpdate): Observable<ApiResponse<FundMovement>> {
    return this.httpClient.post<ApiResponse<FundMovement>>(`${this.baseUrl}/opening/${fundId}`, payload);
  }

  /** Posts the Draft movement: journal entry, bank movement and the fund to Active. */
  public post(id: string): Observable<ApiResponse<FundMovement>> {
    return this.httpClient.post<ApiResponse<FundMovement>>(`${this.baseUrl}/${id}/post`, {});
  }

  public addAttachment(id: string, file: File): Observable<ApiResponse<FundMovement>> {
    const form = new FormData();
    form.append('file', file, file.name);
    return this.httpClient.post<ApiResponse<FundMovement>>(`${this.baseUrl}/${id}/attachment`, form);
  }

  public removeAttachment(id: string, name: string): Observable<ApiResponse<FundMovement>> {
    return this.httpClient.delete<ApiResponse<FundMovement>>(`${this.baseUrl}/${id}/attachment`, { params: { name } });
  }

  public delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.baseUrl}/${id}`);
  }
}
